module.exports = {"130984001":"瀛州路街道","130984002":"城垣西路街道","130984101":"米各庄镇","130984102":"景和镇","130984103":"卧佛堂镇","130984104":"束城镇","130984105":"留古寺镇","130984106":"沙河桥镇","130984107":"诗经村镇","130984108":"尊祖庄镇","130984109":"兴村镇","130984110":"行别营镇","130984111":"故仙镇","130984201":"黎民居乡","130984203":"沙洼乡","130984204":"西九吉乡","130984205":"北石槽乡","130984209":"时村乡","130984212":"龙华店乡","130984213":"果子洼回族乡","130984403":"河北河间经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130984.json
// module id = 318
// module chunks = 0